import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyMaskModule } from 'ngx-currency-mask';
import { SharedModule } from '../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SlickModule } from 'ngx-slick';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CollectionListComponent } from './list/list.component';
import { CollectionCreateComponent } from './create/create.component';
import { CollectionDetailsComponent } from './details/details.component';
import { NgxMaskModule } from 'ngx-mask';
import { MatRadioModule, MatSelectModule, MatDatepickerModule } from '@angular/material';
import { CollectionService } from './collection.service';
import { CepService } from './modal-cep/cep.service';
import { CepModalComponent } from './modal-cep/modal-find/cep-modal.component';
import { CepModalListComponent } from './modal-cep/modal-list/cep-modal-list.component';
import { CepModalInfoComponent } from './modal-cep/modal-info/cep-modal-info.component';
import { CollectionValueAndDateComponent } from './value-date/value-date.component';
import { CollectionResumeFinalComponent } from './resume-final/resume-final.component';
import { CollectionResumeBilletComponent } from './resume-billet/resume-billet.component';
import { CollectionGuardService } from './collection.service.guard';


@NgModule({
imports: [
	CommonModule,
	CurrencyMaskModule,
	SharedModule,
	RouterModule,
	MatCardModule,
	MatTableModule,
	MatCheckboxModule,
	MatRadioModule,
	FormsModule,
	ReactiveFormsModule,
	SlickModule.forRoot(),
	NgxMaskModule.forRoot(),
	MatSelectModule,
	MatDatepickerModule
],
declarations: [
	CollectionListComponent,
	CollectionCreateComponent,
	CollectionDetailsComponent,
	CollectionValueAndDateComponent,
	CollectionResumeFinalComponent,
	CollectionResumeBilletComponent,
	CepModalComponent,
	CepModalListComponent,
	CepModalInfoComponent
],
providers: [
	CollectionService,
	CepService,
	CollectionGuardService
],
entryComponents: [
	CepModalComponent,
	CepModalListComponent,
	CepModalInfoComponent
],
})
export class CollectionModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/collection/collection.module.ts